import request from './services/axios.js'

export default {
  getNum: (params) => {
    return request({
      params,
      url: '/cart/shopCartCount.do',
      method: 'get'
    })
  }
}
